import PropTypes from "prop-types";
import React from "react";
import { TextField } from "react-admin";
import { useAppDataProvider } from "../../dataprovider";
import { WarehouseType } from "../../Enums/WarehouseType";
import { makeStyles } from "@material-ui/core";
import classnames from "classnames";
import { PbhRequestStatus } from "../../Enums/PbhRequestStatus";
import { useAuth } from "@airborne/react-admin";
const useStyles = makeStyles({
  wh: { background: "#ACD1AF" },
  detail: { background: "#EEEE9B" },
  res: { background: "#2977fc75" },
  none: { background: "#2977fc75" },
  accepted: { background: "#ACD1AF" },
  rejected: { background: "#FA8072" },
  offered: { background: "#EEEE9B" },
});

export const PbhWhField = props => {
  const { user } = useAuth();
  const statusArray = [
    PbhRequestStatus.UnshippedSvc,
    PbhRequestStatus.AlternatePnOffered,
    PbhRequestStatus.AlternatePnAccepted,
    PbhRequestStatus.AlternatePnRejected,
    PbhRequestStatus.RejectionProposal,
  ];

  if (!user?.isCustomer) statusArray.push(PbhRequestStatus.Reserved);

  const classes = useStyles();
  const dataProvider = useAppDataProvider();
  const [data, setData] = React.useState<any>(null);
  React.useEffect(() => {
    if (statusArray.includes(props.record.requestStatus)) {
      getData();
    }
  }, [props.record[props.source], props.whType]);
  const getData = () => {
    dataProvider
      .getWhInfoByPn(
        `pn=${props?.record?.[props.source]}&customerCode=${props?.record?.customerCode}&whType=${props.whType}`
      )
      .then(response => {
        if (response?.data?.data != null) {
          setData({ ...response?.data?.data });
        } else {
          setData(null);
        }
      })
      .catch(error => {
        console.log(error);
      });
  };
  const isColored = source => {
    if (data?.count > 0 && props.whType == source) {
      return true;
    }
  };

  return (
    <TextField
      {...props}
      className={classnames(
        props.whType == WarehouseType.AltPn
          ? props.record.alternatePnColorCode === PbhRequestStatus.AlternatePnNone
            ? [classes.none]
            : props.record.alternatePnColorCode === PbhRequestStatus.AlternatePnAccepted
              ? [classes.accepted]
              : props.record.alternatePnColorCode === PbhRequestStatus.AlternatePnOffered
                ? [classes.offered]
                : [classes.rejected]
          : {
              [classes.wh]: isColored(WarehouseType.Wh),
              [classes.detail]:
                isColored(WarehouseType.Wo) || isColored(WarehouseType.Px) || isColored(WarehouseType.Ro),
              [classes.res]: isColored(WarehouseType.Res),
            }
      )}
      style={{
        display: "grid",
        alignContent: "center",
        alignItems: "center",
        justifyItems: "center",
        justifyContent: "center",
        padding: "5px 15px",
        width: "15px",
      }}
      source="display"
      record={{ ...props.record, ...{ display: data?.[props?.valueSource] ?? "0" } }}
    ></TextField>
  );
};

PbhWhField.propTypes = {
  whType: PropTypes.number,
  valueSource: PropTypes.string,
  ...TextField.prototype,
};

PbhWhField.defaultProps = {
  whType: WarehouseType.AltPn,
  valueSource: "display",
};

export default PbhWhField;
